/** @jsx h */
import { h, Component } from 'preact'
import IconBack from '../../../assets/images/svgs/icon-chevron-left.svg'
import ErrorTracker from './ErrorTracker'

/**
 * This component wraps the side modal that appears when opening
 * a proof point from another modal. Most of the logic is in
 * app/assets/stylesheets/components/infinite-modal.scss
 * and components/ModalCard/Container.jsx
 *
 * ## Slide-in animation
 * Add class .InfiniteModal--slideIn
 * Revert it with .InfiniteModal--slideOut
 *
 * ## Revealing Story animation (using clip-path - StoryCard should be present in DOM)
 * Add class .InfiniteModal--revealStory
 * Revert it with .InfiniteModal--concealStory
 */
export default class InfiniteModal extends Component {
  static Back (props) {
    return <IconBack role='button' tabindex='0' class='InfiniteModal-back' {...props} />
  }

  render (props) {
    return (
      <ErrorTracker>
        <div class={'InfiniteModal ' + props.class}>
          {props.children}
        </div>
      </ErrorTracker>
    )
  }
}
